module.exports = __webpack_public_path__ + "img/bannerWork.eecaf5cd.png";